import PropTypes from 'prop-types';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
export const ChatStyle = styled.div.withConfig({
  displayName: "WidgetChatAreaStyleWrapper__ChatStyle",
  componentId: "sc-1n53y7g-0"
})(["min-height:0;height:100%;display:flex;flex-direction:column;"]);
function WidgetChatAreaStyleWrapper({
  children
}) {
  return /*#__PURE__*/_jsx(ChatStyle, {
    children: children
  });
}
WidgetChatAreaStyleWrapper.displayName = 'WidgetChatAreaStyleWrapper';
WidgetChatAreaStyleWrapper.propTypes = {
  children: PropTypes.node.isRequired
};
export default WidgetChatAreaStyleWrapper;